import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";

/** Soft-deleted or reviewer-rejected comments stay out of review UI lists. */
export function isVisibleReviewComment(comment: BaseTicketComment): boolean {
  return !comment.isDeleted && comment.liked !== false;
}

export function isRejectedReviewComment(comment: BaseTicketComment): boolean {
  return !comment.isDeleted && comment.liked === false;
}

export function visibleReviewComments(
  comments: BaseTicketComment[] | undefined,
): BaseTicketComment[] {
  return (comments ?? []).filter(isVisibleReviewComment);
}

export function rejectedReviewComments(
  comments: BaseTicketComment[] | undefined,
): BaseTicketComment[] {
  return (comments ?? []).filter(isRejectedReviewComment);
}

export function rejectedReviewCommentCount(
  comments: BaseTicketComment[] | undefined,
): number {
  return rejectedReviewComments(comments).length;
}

/** Comments shown in the review panel carousel (optionally includes rejected). */
export function reviewCommentsForPanel(
  comments: BaseTicketComment[] | undefined,
  includeRejected: boolean,
): BaseTicketComment[] {
  const list = comments ?? [];
  if (includeRejected) {
    return list.filter((c) => !c.isDeleted);
  }
  return visibleReviewComments(list);
}

export function visibleAiCommentCount(
  comments: BaseTicketComment[] | undefined,
): number {
  return visibleReviewComments(comments).filter((c) => c.isAI).length;
}

export function visibleHumanCommentCount(
  comments: BaseTicketComment[] | undefined,
): number {
  return visibleReviewComments(comments).filter((c) => !c.isAI).length;
}
